import type { BlockSpacing } from "@newxsystems/types";

/** The single vertical rhythm contract for every Toot content block. */
export const TOOT_SECTION_SPACING = {
  tight: "py-8 lg:py-10",
  normal: "py-10 sm:py-12 lg:py-16",
  loose: "py-12 sm:py-18 lg:py-24",
} satisfies Record<BlockSpacing, string>;

export const getTootSectionSpacing = (spacing?: BlockSpacing | null) =>
  spacing ? TOOT_SECTION_SPACING[spacing] : undefined;
